<template>
  <div class="animated fadeIn">
    <b-row class="mt-2 mb-2">
      <b-col>
        <h2>งานทั้งหมด</h2>
      </b-col>
      <b-col>
        <b-button
          @click="$router.push({ name: 'สร้างใบขอราคา'})"
          class="float-right"
          variant="primary"
        >ประกาศงานขนส่งใหม่</b-button>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <b-card>
          <!-- <b-row>
            <b-col sm="12">
              <label for="name">ชื่องาน</label>
              <b-input-group>
                <b-form-input v-model="name" id="name"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>-->
          <h5>ค้นหางาน</h5>
          <b-row class="mt-3">
            <b-col sm="12" xl="4">
              <MultiSelectTruckTag label="ประเภทรถ" v-model="truckType" />
            </b-col>
            <b-col sm="12" xl="4">
              <MultiSelectTag label="ภูมิภาคต้นทาง" v-model="origin" :options="regionOptions" />
            </b-col>
            <b-col sm="12" xl="4">
              <MultiSelectTag
                label="ภูมิภาคปลายทาง"
                v-model="destination"
                :options="regionOptions"
              />
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <b-button variant="primary" @click="doSearch">ค้นหา</b-button>
              <b-button variant="warning" class="ml-3" @click="resetSearch">ล้างค่า</b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          สำหรับผู้ให้บริการขนส่งที่สนใจรับข้อมูลงานแบบ real-time ผ่านทางไลน์ สามารถแอดไลน์ <b>@LogistyCarrier</b> (มีสัญลักษณ์ @) หรือคลิก
          <a href="https://lin.ee/qSQaKeh" target="_blank">
            <img
              src="https://scdn.line-apps.com/n/line_add_friends/btn/th.png"
              alt="เพิ่มเพื่อน"
              height="36"
              border="0"
            />
          </a>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card no-body>
          <b-tabs v-model="tabIndex" card>
            <b-tab
              :title="'งานทั้งหมด' + ' (' + quotescache.length + ')'"
              :title-link-class="linkClass(0)"
            >
              <b-row>
                <b-col>
                  <b-table
                    :items="quotes"
                    :fields="tableFields"
                    :tbody-tr-class="broadcastTableClass"
                    responsive
                    hover
                    @row-clicked="quotesClick"
                  >
                    <template
                      v-slot:cell(goodsDescriptions)="row"
                    >{{ row.item.goodsDescriptions }} <span v-if="!row.item.viewed" class="badge badge-success">ใหม่</span></template>

                    <template v-slot:cell(origin)="row">
                      <span v-for="(item,index) in row.item.origin" :key="index">
                        {{ item.region }}
                        <br v-if="index != row.item.origin.length -1" />
                      </span>
                    </template>

                    <template v-slot:cell(destination)="row">
                      <span v-for="(item,index) in row.item.destination" :key="index">
                        {{ item.region }}
                        <br v-if="index != row.item.destination.length -1" />
                      </span>
                    </template>

                    <template v-slot:cell(jobType)="row">{{ row.item.jobType }}</template>

                    <template
                      v-slot:cell(frequency)="row"
                    >{{ row.item.frequency + ' ' + row.item.frequencyType }}</template>

                    <template v-slot:cell(truckType)="row">
                      {{ row.item.truckType.length }} ชนิด
                      <span>
                        <img
                          class="logisty-icon truck-eye"
                          :id="'view-public-trucktype-list-' + row.item._id"
                          src="/img/icon/icon_eye.png"
                        />
                      </span>
                      <b-popover
                        :target="'view-public-trucktype-list-' + row.item._id"
                        placement="auto"
                        triggers="hover focus"
                      >
                        <div
                          v-for="(truck,index) in row.item.truckType"
                          v-bind:key="index"
                          style="border-bottom: 1px solid;"
                        >
                          <b-row>
                            <b-col align-self="center" sm="8">{{ getTypeName(truck) }}</b-col>
                            <b-col align-self="center" sm="4">
                              <b-img
                                class="popover-truck-type"
                                :src="'/img/truck_icon/' + getIcon(truck)"
                                fluid
                              />
                            </b-col>
                          </b-row>
                        </div>
                      </b-popover>
                    </template>

                    <template
                      v-slot:cell(status)="row"
                    >{{ row.item.status < 20 ? 'เปิดรับ' : 'ปิด' }}</template>

                    <template v-slot:cell(actions)="row">
                      <b-button
                        variant="primary"
                        size="sm"
                        target="_blank"
                        :to="{name: 'รายละเอียดใบขอราคา', params: {jobId:row.item._id}}"
                        class="mr-1"
                      >ดูรายละเอียด</b-button>
                      <br />
                      <span class="quote-create-date text-muted">ประกาศเมื่อ {{ $moment(row.item.createdAt).format('LL') }}</span>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col>
                  <b-pagination
                    class="flex-wrap"
                    v-model="quoteCurrentPage"
                    :total-rows="quotescache.length"
                    :per-page="perPage"
                    first-text="หน้าแรก"
                    prev-text="ก่อนหน้า"
                    next-text="ถัดไป"
                    last-text="หน้าสุดท้าย"
                    @input="updateQuotePage"
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab
              :title="'งานที่ฉันประกาศ' + ' (' + myquotescache.length + ')'"
              :title-link-class="linkClass(1)"
            >
              <b-row>
                <b-col>
                  <b-table
                    :items="myquotes"
                    :fields="tableMyquoteFields"
                    :tbody-tr-class="rowClass"
                    responsive
                    hover
                    @row-clicked="myquotesClick"
                  >
                    <template
                      v-slot:cell(goodsDescriptions)="row"
                    >{{ row.item.goodsDescriptions }}</template>

                    <template v-slot:cell(origin)="row">
                      <span v-for="(item,index) in row.item.origin" :key="index">
                        {{ item.region }}
                        <br v-if="index != row.item.origin.length -1" />
                      </span>
                    </template>

                    <template v-slot:cell(destination)="row">
                      <span v-for="(item,index) in row.item.destination" :key="index">
                        {{ item.region }}
                        <br v-if="index != row.item.destination.length -1" />
                      </span>
                    </template>

                    <template v-slot:cell(jobType)="row">{{ row.item.jobType }}</template>

                    <template
                      v-slot:cell(frequency)="row"
                    >{{ row.item.frequency + ' ' + row.item.frequencyType }}</template>

                    <template v-slot:cell(truckType)="row">
                      {{ row.item.truckType.length }} ชนิด
                      <span>
                        <img
                          class="logisty-icon"
                          :id="'view-public-trucktype-list-' + row.item._id"
                          src="/img/icon/icon_eye.png"
                        />
                      </span>
                      <b-popover
                        :target="'view-public-trucktype-list-' + row.item._id"
                        placement="auto"
                        triggers="hover focus"
                      >
                        <div
                          v-for="(truck,index) in row.item.truckType"
                          v-bind:key="index"
                          style="border-bottom: 1px solid;"
                        >
                          <b-row>
                            <b-col align-self="center" sm="8">{{ getTypeName(truck) }}</b-col>
                            <b-col align-self="center" sm="4">
                              <b-img
                                class="popover-truck-type"
                                :src="'/img/truck_icon/' + getIcon(truck)"
                                fluid
                              />
                            </b-col>
                          </b-row>
                        </div>
                      </b-popover>
                    </template>

                    <template
                      v-slot:cell(status)="row"
                    >{{ row.item.status < 20 ? 'เปิดรับ' : 'ปิด' }}</template>

                    <template
                      v-slot:cell(responseDocCount)="row"
                    >
                      <span v-if="row.item.responseDocCount > 0" class="fa-stack fa-2x new-doc-numbered-icon">
                        <i class="fa fa-circle fa-stack-2x"></i>
                        <strong class="fa-stack-1x text-white">{{ row.item.responseDocCount }}</strong>
                      </span>
                    </template>

                    <template v-slot:cell(actions)="row">
                      <b-button
                        variant="primary"
                        size="sm"
                        target="_blank"
                        :to="{name: 'รายละเอียดใบขอราคาของฉัน', params: {jobId:row.item._id}}"
                        class="mr-1"
                      >ดูรายละเอียด</b-button>
                      <br />
                      <span class="quote-create-date text-muted">ประกาศเมื่อ {{ $moment(row.item.createdAt).format('LL') }}</span>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col>
                  <b-pagination
                    class="flex-wrap"
                    v-model="myquoteCurrentPage"
                    :total-rows="myquotescache.length"
                    :per-page="perPage"
                    first-text="หน้าแรก"
                    prev-text="ก่อนหน้า"
                    next-text="ถัดไป"
                    last-text="หน้าสุดท้าย"
                    @input="updateMyquotePage"
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-tab>

            <!-- quoted list -->
            <b-tab
              :title="'งานที่เสนอราคา' + ' (' + myquotedcache.length + ')'"
              :title-link-class="linkClass(1)"
            >
              <b-row>
                <b-col>
                  <b-table
                    :items="myquoteds"
                    :fields="tableQuotedFields"
                    :tbody-tr-class="rowClass"
                    responsive
                    hover
                    @row-clicked="quotedsClick"
                  >
                    <template
                      v-slot:cell(goodsDescriptions)="row"
                    >{{ row.item.goodsDescriptions }}</template>

                    <template v-slot:cell(origin)="row">
                      <span v-for="(item,index) in row.item.origin" :key="index">
                        {{ item.region }}
                        <br v-if="index != row.item.origin.length -1" />
                      </span>
                    </template>

                    <template v-slot:cell(destination)="row">
                      <span v-for="(item,index) in row.item.destination" :key="index">
                        {{ item.region }}
                        <br v-if="index != row.item.destination.length -1" />
                      </span>
                    </template>

                    <template v-slot:cell(jobType)="row">{{ row.item.jobType }}</template>

                    <template
                      v-slot:cell(frequency)="row"
                    >{{ row.item.frequency + ' ' + row.item.frequencyType }}</template>

                    <template v-slot:cell(truckType)="row">
                      {{ row.item.truckType.length }} ชนิด
                      <span>
                        <img
                          class="logisty-icon"
                          :id="'view-public-trucktype-list-' + row.item._id"
                          src="/img/icon/icon_eye.png"
                        />
                      </span>
                      <b-popover
                        :target="'view-public-trucktype-list-' + row.item._id"
                        placement="auto"
                        triggers="hover focus"
                      >
                        <div
                          v-for="(truck,index) in row.item.truckType"
                          v-bind:key="index"
                          style="border-bottom: 1px solid;"
                        >
                          <b-row>
                            <b-col align-self="center" sm="8">{{ getTypeName(truck) }}</b-col>
                            <b-col align-self="center" sm="4">
                              <b-img
                                class="popover-truck-type"
                                :src="'/img/truck_icon/' + getIcon(truck)"
                                fluid
                              />
                            </b-col>
                          </b-row>
                        </div>
                      </b-popover>
                    </template>

                    <template
                      v-slot:cell(status)="row"
                    >{{ row.item.status < 20 ? 'เปิดรับ' : 'ปิด' }}</template>

                    <template v-slot:cell(actions)="row">
                      <b-button
                        variant="primary"
                        size="sm"
                        target="_blank"
                        :to="{name: 'รายละเอียดใบขอราคา', params: {jobId:row.item._id}}"
                        class="mr-1"
                      >ดูรายละเอียด</b-button>
                      <br />
                      <span class="quote-create-date text-muted">ประกาศเมื่อ {{ $moment(row.item.createdAt).format('LL') }}</span>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col>
                  <b-pagination
                    class="flex-wrap"
                    v-model="myquotedCurrentPage"
                    :total-rows="myquotedcache.length"
                    :per-page="perPage"
                    first-text="หน้าแรก"
                    prev-text="ก่อนหน้า"
                    next-text="ถัดไป"
                    last-text="หน้าสุดท้าย"
                    @input="updateMyquotePage"
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
    <ModalLoading />
  </div>
</template>
<style lang="scss">
.table td,
.table th {
  min-width: 150px;
}
.quote-title-col {
  max-width: 200px;
}

.quote-create-date {
  font-size: 80%;
}

.quote-action-col {
  white-space: nowrap
}

.new-doc-numbered-icon {
  font-size: 1em;
  color: red;
}

.truck-eye {
  display: none;
}

.table-hover tbody tr:hover td {
  background: #eff5f5;
  cursor: pointer;
  .truck-eye {
    display: inline;
  }
}
</style>

<script>
import TruckType from '../../services/http/TruckType'
import Quote from '../../services/http/Quote'

import MultiSelectTag from '../../components/MultiSelectTag'

import ModalLoading from '../../components/ModalLoading'

import MultiSelectTruckTag from '../../components/MultiSelectTruckTag'

export default {
  components: {
    MultiSelectTag,
    ModalLoading,
    MultiSelectTruckTag
  },
  data () {
    return {
      name: null,
      truckType: [],
      truckTypeOptions: [],
      origin: [],
      destination: [],
      regionOptions: [
        { value: 'ภาคกลาง' },
        { value: 'ภาคเหนือ' },
        { value: 'ภาคตะวันออก' },
        { value: 'ภาคตะวันออกเฉียงเหนือ' },
        { value: 'ภาคใต้' }
      ],
      perPage: 10,
      quotes: [],
      quotescache: [],
      quoteCurrentPage: 1,
      myquotes: [],
      myquotescache: [],
      myquoteCurrentPage: 1,
      tabIndex: 0,
      tableFields: [
        { key: 'goodsDescriptions', label: 'สินค้า', class: 'text-center quote-title-col' },
        { key: 'origin', label: 'ต้นทาง', class: 'text-center' },
        { key: 'destination', label: 'ปลายทาง', class: 'text-center' },
        // { key: 'startDate', label: 'วันที่เริ่มงาน', class: 'text-center' },
        { key: 'jobType', label: 'ลักษณะงาน', class: 'text-center' },
        { key: 'frequency', label: 'ความถี่', class: 'text-center' },
        { key: 'truckType', label: 'ชนิดรถ', class: 'text-center' },
        { key: 'status', label: 'สถานะ', class: 'text-center' },
        // { key: 'createdAt', label: 'วันที่ประกาศ', class: 'text-center' },
        { key: 'actions', label: '', class: 'text-center quote-action-col' }
      ],
      tableMyquoteFields: [
        { key: 'goodsDescriptions', label: 'สินค้า', class: 'text-center quote-title-col' },
        // { key: 'status', label: 'สถานะ', class: 'text-center' },
        { key: 'origin', label: 'ต้นทาง', class: 'text-center' },
        { key: 'destination', label: 'ปลายทาง', class: 'text-center' },
        // { key: 'startDate', label: 'วันที่เริ่มงาน', class: 'text-center' },
        { key: 'jobType', label: 'ลักษณะงาน', class: 'text-center' },
        { key: 'frequency', label: 'ความถี่', class: 'text-center' },
        { key: 'truckType', label: 'ชนิดรถ', class: 'text-center' },
        { key: 'status', label: 'สถานะ', class: 'text-center' },
        // { key: 'createdAt', label: 'วันที่ประกาศ', class: 'text-center' },
        { key: 'responseDocCount', label: 'ใบเสนอราคาใหม่', class: 'text-center' },
        { key: 'actions', label: '', class: 'text-center quote-action-col' }
      ],
      tableQuotedFields: [
        { key: 'goodsDescriptions', label: 'สินค้า', class: 'text-center quote-title-col' },
        // { key: 'status', label: 'สถานะ', class: 'text-center' },
        { key: 'origin', label: 'ต้นทาง', class: 'text-center' },
        { key: 'destination', label: 'ปลายทาง', class: 'text-center' },
        // { key: 'startDate', label: 'วันที่เริ่มงาน', class: 'text-center' },
        { key: 'jobType', label: 'ลักษณะงาน', class: 'text-center' },
        { key: 'frequency', label: 'ความถี่', class: 'text-center' },
        { key: 'truckType', label: 'ชนิดรถ', class: 'text-center' },
        { key: 'status', label: 'สถานะ', class: 'text-center' },
        // { key: 'createdAt', label: 'วันที่ประกาศ', class: 'text-center' },
        { key: 'actions', label: '', class: 'text-center quote-action-col' }
      ],
      jobStatus: [
        { value: '0', text: 'ร่าง', variant: 'info' },
        { value: '2', text: 'รอเผยแพร่', variant: 'info' },
        { value: '5', text: 'เผยแพร่', variant: 'primary' },
        { value: '7', text: 'มีคนส่งเอกสาร', variant: 'primary' },
        { value: '20', text: 'ปิดงาน', variant: 'success' }
      ],
      myquotedcache: [],
      myquoteds: [],
      myquotedCurrentPage: 1
    }
  },
  async mounted () {
    // prepare tab active
    switch (this.$route.params.tabName) {
      case 'all':
        this.tabIndex = 0
        break
      case 'myjob' :
        this.tabIndex = 1
        break
      case 'myquoted':
        this.tabIndex = 2
        break
      default:
        this.tabIndex = 0
        break
    }

    window.analytics.track('quote-index-open')
    // prepare trucktype
    try {
      var truckType = new TruckType()
      var truckTypeData = await truckType.getAllTruckType()
      if (truckTypeData.code === 1) {
        this.truckTypeOptions = truckTypeData.data
      } else {
        alert('ไม่สามารถข้อมูลรถได้')
      }
    } catch (error) {
      alert('โปรดติดต่อผู้ดูแลระบบ')
      console.log(error)
    }

    Window.Event.$emit('showModalLoading')

    this.doSearch()

    // load myquote
    try {
      var quote = new Quote()
      var result = await quote.shipperGetAllQuote()
      if (result.code === 1) {
        this.myquotescache = result.data
        let jobs = result.data

        const sortDates = (a, b) => this.$moment(b.createdAt).format('YYYYMMDD') - this.$moment(a.createdAt).format('YYYYMMDD')

        jobs = jobs.sort(sortDates)

        let availableJob = []
        let unavaliableJob = []
        for (var i = 0; i < jobs.length; i++) {
          if (jobs[i].status < 20) {
            availableJob.push(jobs[i])
          } else {
            unavaliableJob.push(jobs[i])
          }
        }

        this.myquotescache = availableJob.concat(unavaliableJob)

        var start = (this.myquoteCurrentPage - 1) * this.perPage
        var end = start + this.perPage
        this.myquotes = this.myquotescache.slice(start, end)
      } else {
        alert('ไม่สามารถข้อมูลงานได้')
      }

      let quoted = await quote.carrierGetQuotedQuoteItem()
      if (quoted.code === 1) {
        this.myquotedcache = quoted.data
        let jobs = quoted.data

        const sortDates = (a, b) => this.$moment(b.createdAt).format('YYYYMMDD') - this.$moment(a.createdAt).format('YYYYMMDD')

        jobs = jobs.sort(sortDates)

        let availableJob = []
        let unavaliableJob = []
        for (let i = 0; i < jobs.length; i++) {
          if (jobs[i].status < 20) {
            availableJob.push(jobs[i])
          } else {
            unavaliableJob.push(jobs[i])
          }
        }

        this.myquotedcache = availableJob.concat(unavaliableJob)

        let start = (this.myquotedCurrentPage - 1) * this.perPage
        let end = start + this.perPage
        this.myquoteds = this.myquotedcache.slice(start, end)
      } else {
        alert('ไม่สามารถข้อมูลงานได้')
      }
    } catch (error) {
      alert('โปรดติดต่อผู้ดูแลระบบ')
      console.log(error)
    }

    Window.Event.$emit('closeModalLoading')
  },
  methods: {
    async doSearch () {
      try {
        var quote = new Quote()
        var data = {
          all: true,
          title: this.name,
          sortBy: {
            'createdAt': -1
          }
          // select: {
          //   title: 1,
          //   vendorGroups: 1,
          //   private: 1
          // }
        }
        var filterBy = {}
        if (this.origin.length > 0) {
          filterBy = {
            ...filterBy,
            origin: {
              $elemMatch: {
                region: { '$in': this.textObjToArr(this.origin) }
              }
            }
          }
        }

        if (this.destination.length > 0) {
          filterBy = {
            ...filterBy,
            destination: {
              $elemMatch: {
                region: { '$in': this.textObjToArr(this.destination) }
              }
            }
          }
        }

        if (this.truckType.length > 0) {
          var filterType = this.truckType.map(x => x._id)
          filterBy = {
            ...filterBy,
            truckType: { '$in': filterType }
          }
        }

        data = {
          ...data,
          filterBy: filterBy
        }

        // console.log(data)

        window.analytics.track('search-quote', {
          origin: this.textObjToArr(this.origin),
          destination: this.textObjToArr(this.destination),
          truckType: this.truckType.map(x => x.typeName)
        })

        var result = await quote.carrierGetAllQuote(data)
        if (result.code === 1) {
          // reposition job
          var jobs = result.data
          var availableJob = []
          var unavaliableJob = []
          for (var i = 0; i < jobs.length; i++) {
            if (jobs[i].status < 20) {
              availableJob.push(jobs[i])
            } else {
              unavaliableJob.push(jobs[i])
            }
          }

          this.quotescache = availableJob.concat(unavaliableJob)

          var start = (this.quoteCurrentPage - 1) * this.perPage
          var end = start + this.perPage
          this.quotes = this.quotescache.slice(start, end)
          // send update viewed
          // this.sendUpdateViewed(this.quotes)
        } else {
          alert('ไม่สามารถข้อมูลงานได้')
        }
      } catch (error) {
        alert('โปรดติดต่อผู้ดูแลระบบ')
        console.log(error)
      }
    },
    resetSearch () {
      this.name = null
      this.truckType = []
      this.origin = []
      this.destination = []
      this.doSearch()
    },
    textObjToArr (obj) {
      var out = obj.map(x => x.value)
      return out
    },
    linkClass (idx) {
      if (this.tabIndex === idx) {
        return []
      } else {
        return ['bg-mute']
      }
    },
    updateQuotePage () {
      var start = (this.quoteCurrentPage - 1) * this.perPage
      var end = start + this.perPage
      this.quotes = this.quotescache.slice(start, end)
    },
    updateMyquotePage () {
      var start = (this.myquoteCurrentPage - 1) * this.perPage
      var end = start + this.perPage
      this.myquotes = this.myquotescache.slice(start, end)
    },
    updateMyquotedPage () {
      var start = (this.myquotedCurrentPage - 1) * this.perPage
      var end = start + this.perPage
      this.myquoteds = this.myquotedcache.slice(start, end)
    },
    getIcon (key) {
      var ret = this.truckTypeOptions.find(x => x._id === key)
      if (ret) {
        return ret.icon
      } else {
        return 'truck_normal.png'
      }
    },
    getTypeName (key) {
      var ret = this.truckTypeOptions.find(x => x._id === key)
      if (ret) {
        return ret.typeName
      } else {
        return 'unknown'
      }
    },
    rowClass (item, type) {
      if (!item) return

      if (item.status >= 20) {
        return ['bg-logisty-job-unavaliable', 'text-logisty-text-job-unavaliable']
        // return 'bg-white'
      } else {
        return 'bg-white'
      }
    },
    broadcastTableClass (item, type) {
      if (!item) return

      if (item.status >= 20) {
        return ['bg-logisty-job-unavaliable', 'text-logisty-text-job-unavaliable']
      }

      if (!item.opened) {
        return 'bg-logisty-job-unopened'
      } else {
        return 'bg-white'
      }
    },
    sendUpdateViewed (quotes) {
      let quoteList = []
      quotes.forEach((quote) => {
        if (!quote.viewed && !quote.updatedViwed) {
          // push id to list
          quoteList.push(quote._id)
          quote['updatedViwed'] = true
        }
      })

      // do send update
      if (quoteList.length > 0) {
        let data = {
          qrJobIdList: quoteList,
          viewed: true
        }

        let quoteHttp = new Quote()
        quoteHttp.publicUpdateJobLog(data)
      }
    },
    quotesClick (item) {
      this.$router.open({ name: 'รายละเอียดใบขอราคา', params: { jobId: item._id } })
    },
    myquotesClick (item) {
      this.$router.open({ name: 'รายละเอียดใบขอราคา', params: { jobId: item._id } })
    },
    quotedsClick (item) {
      this.$router.open({ name: 'รายละเอียดใบขอราคา', params: { jobId: item._id } })
    }
  },
  watch: {
    quotes () {
      if (this.quotes.length > 0) {
        this.sendUpdateViewed(this.quotes)
      }
    },
    '$route.params.tabName': function (tabName) {
      // prepare tab active
      switch (tabName) {
        case 'all':
          this.tabIndex = 0
          break
        case 'myjob' :
          this.tabIndex = 1
          break
        case 'myquoted':
          this.tabIndex = 2
          break
        default:
          this.tabIndex = 0
          break
      }
    }
  }
}
</script>
